import React from "react";

const cell3Nav = (
  { clickFunction, layerColors, isolatedLayer, allLayerFocus },
  ref
) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 289.8 223.2"
    className={`cell-svg nav ${isolatedLayer && "isolated"} ${
      allLayerFocus && "all-focus"
    }`}
    onClick={clickFunction}
    ref={ref}
  >
    <g
      id="Color_4"
      className={`${isolatedLayer === 1 ? "fill-group focus" : "fill-group"}`}
    >
      <g>
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M17.1,25.7c3.1,0.6,6.3,0,7.5-2.8c1.3-3.1,4.2-7.8,0.8-9.8c-1.1-0.7-3.3,1.8-3.9,3.9
			c-0.3,1.1,0.2,2.4-0.2,3.4c-1,2.7-4.1,2.1-4.9,0c-0.6-1.5-0.2-3.4-0.3-5.2c0-3.5,6-2.1,4.8-5.2c-1.1-2.9-7.1-2.7-7.9,0.1
			c-1.2,4.4-1.2,9.3-0.6,13.8C12.5,24.9,15.3,25.4,17.1,25.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M11.8,17.1c-0.9-0.6-1.9-1.7-2.6-1.5c-1,0.3-1.2,1.9-0.9,3.2C9.4,18.3,10.6,17.7,11.8,17.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M182.8,185.3c-0.4-0.6-0.4-1.8,0-2.4c0.2-0.3,1.3-0.3,1.5,0c0.4,0.6,0.4,1.8,0,2.4
			C184.1,185.6,183,185.6,182.8,185.3z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M183,200.1c-0.6-0.4,0.1-1.3,0.8-1.6c0.5-0.2,1.3-0.3,1.6,0c0.3,0.3,0.3,1.3,0,1.5
			C184.7,200.5,183.5,200.6,183,200.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M181.9,211.8c0.9,1.1-0.8,1.5-1.5,1.5c-0.6,0-1.4-1-0.8-1.5C180.2,211.4,181.6,211.4,181.9,211.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M203,202.7c0.9-0.5,1.3-2.4,2.5-1.6c0.3,0.2,0.2,1.1,0,1.6C204.9,204.2,203.9,203.3,203,202.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M230.8,189.1c-1.9,0.5-0.6-1.2-0.7-1.7c-0.1-0.6,1-1.3,1.4-0.8C231.9,187.3,232.1,188.8,230.8,189.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M234.5,202.3c0.3-0.9-1.1-1.7,1.7-2.6C235.9,200.5,237.3,201.3,234.5,202.3z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M245.1,212.6c-0.5,0.2-1.3,0.3-1.6,0c-0.6-0.6,0.1-1.4,0.8-1.6c0.8-0.2,2.1-0.4,2.4,0
			C247.5,212,245.9,212.3,245.1,212.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M259.8,200.1c-0.3,0-0.6-0.5-0.9-0.8c1-1,2.2-1,3.5-0.9C261.7,199.3,260.8,200,259.8,200.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M268.4,188.6c-0.7-0.1-1.4-1.1-0.8-1.5c0.7-0.4,2.3-0.6,2.3,0.7C269.9,188.1,269,188.6,268.4,188.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M279.8,182.4c-0.3-0.4-0.3-1.2,0-1.6c0.5-0.7,1.8-1.5,2.3-0.8c0.7,0.9-0.3,2.2-0.6,3.4
			C280.8,183,280.1,182.9,279.8,182.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M274.6,206.3c3,1.1-1.2,1.3-0.8,2.4c-0.8,0.2-1.7-0.3-1.6-0.8C272.5,206.9,273.9,206.1,274.6,206.3z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M87.3,182.2c-0.8,0.4-1.3-0.2-0.8-0.7c0.3-0.3,1.1-0.1,1.6-0.1C87.9,181.7,87.7,182.1,87.3,182.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M87.6,206.7c-0.8,0.4-1.2,0-0.8-0.8c0.3-0.7,1-1.4,1.6-0.8C88.9,205.7,88.3,206.4,87.6,206.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M35.3,203c-0.6-1.1,0.4-2.1,1.5-1.5c0.3,0.1,0.3,1.2,0,1.5C36.5,203.2,35.4,203.2,35.3,203z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M35.2,212.7c-0.3,0-0.6,0-0.9,0c0.9-0.5,1.2-2.4,2.5-1.6c0.3,0.2,0.3,1.2,0,1.5
			C36.6,212.9,35.8,212.7,35.2,212.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52.6,203.7c-0.3,0-0.6,0-0.9,0c0.6-0.6,1.1-1.5,1.7-1.6c0.6-0.1,1.3,0.9,0.8,1.5
			C54,203.9,53.2,203.7,52.6,203.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M136.7,206.8c-0.5-0.2,0.1-1.2,0.8-1.5c0.5-0.2,1.4-0.3,1.6,0C139.6,206.1,139.1,207.7,136.7,206.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M158.5,206.7c0.3-0.8,0.3-2.2,1.7-1.7c0.7,0.2,1.4,1.1,0.8,1.5C160.4,207,159.3,206.7,158.5,206.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M157.4,196.1c-0.2,0-0.6-0.5-0.9-0.7c0.9-0.5,1.1-2.1,2.6-1.8C158.8,194.5,160.4,195.5,157.4,196.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M209.8,186.8c-0.9,0.3-1.3-0.2-0.8-0.8c0.7-0.8,1-2.2,2.5-1.9C211.2,185.1,212.6,185.9,209.8,186.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M60.2,183.4c-0.7-0.1-1.3-0.8-0.8-1.6c1.5-2.4,1.6,0.9,2.6,0.8C61.4,182.9,60.8,183.4,60.2,183.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M19.4,204.8c-0.5,0.1-1.2-0.8-0.8-1.5c0.4-0.7,1.1-1.2,1.7-1.8C20.1,202.7,21,204.5,19.4,204.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M70.1,206.8c-0.6,0-1.3-0.9-0.8-1.5c0.3-0.3,1.3-0.3,1.5,0C71.5,205.9,70.8,206.8,70.1,206.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M250.8,182.8c0-0.9-0.3-1.9,0.1-2.5c0.2-0.3,1-0.1,1.6-0.1C252.2,181,253.6,181.9,250.8,182.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M223.1,212c-0.2,0.7-1,1.5-1.6,1.6c-0.6,0.1-1.2-0.8-0.8-1.5c0.4-0.7,1.1-1.2,1.7-1.8
			C222.6,210.9,223.2,211.5,223.1,212z"
        />
      </g>
    </g>
    <g
      id="Color_3"
      className={`${isolatedLayer === 2 ? "fill-group focus" : "fill-group"} `}
    >
      <g>
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M99.6,48.5c11.6,0.1,23.9,1.6,35-1.5c-0.6-0.9-1-2.1-1.9-2.4c-4.7-1.8-9.9,2.3-15-0.5
			c-1.6-0.9-3.7,2.3-5.8,1.2c-6.8-3.5-13.7-1-20.3-1.3c-4.3-0.2-9.5-1.1-13.9,1.1c0.6,0.9,1.2,2.3,1.8,2.3
			C86.2,47.6,92.9,48.5,99.6,48.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M77.6,56.5c0.2-2.9-1.4-5.7-0.4-8.9c0.9-3-4.8-2.8-4.9-1.5c-0.5,11.5,0.5,23.3,0.9,34.9c0.1,2-0.5,4.9-0.5,7
			c0.1,9,1.3,18.1,1,27.1c-0.2,6.6-0.8,14-0.3,21c0.1,0.8-1.3,1.8-1.3,2.6c0,0.6,1.3,1.1,1.4,1.7c1.1,11.8-2.9,25.2,2.4,35.8
			c4.8-20.5,1.8-41.5,1.9-62.1C77.9,95,76.4,75.8,77.6,56.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M167.8,47.2c5.6-0.2,11.9,2.9,16.1-2.1c1.7-2.1,2.5-6-2.3-9.2c-1.2,2.2-0.4,6.1-1,6.3
			c-11.7,3-23.7,1.4-35.6,2.4c-0.6,0.1-1.2,1.5-1.7,2.4C151.4,48.8,159.6,47.5,167.8,47.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M143.1,46.7c0.4-0.3,0.3-2.1,0-2.1c-3.4-0.8-8.7-2.3-9.5,0.2C132.6,47.8,139.9,48.8,143.1,46.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M197.5,44.5c-0.9,0-2-0.3-2.5,0.2c-0.4,0.5-0.4,2,0,2.3c3.2,2.2,6.9,1.3,10.3,0.7c0.7-0.1,1.2-1.5,1.8-2.4
			C204,43.8,200.7,44.6,197.5,44.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M213.3,55.6c-0.3-3.9,1.7-10.3-3.6-11c-1.1-0.1-1.9,2.2-1.4,3c1.1,1.8,0.9,3.9,1,5.4
			c1.7,21.5-0.4,43,1.6,64.6c0.1,0.7,2,1.7,2.1,1.5c4.7-4.8,0.7-11.4,2.3-17.4c0.4-1.5-1.3-3.4-1.3-5.1
			C214.6,82.9,214.2,69.4,213.3,55.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M214.9,148.3c0.3-9.4,1.1-18.6-1.9-27.8c-0.1-0.2-2.1-0.1-2.1,0c-1.5,16.7-0.6,33.2-0.4,49.8
			c0,2,1.3,3.7,2.6,5.2c2.6-2.8,0.4-7.3,1.3-10.4C215.9,159.8,214.7,153.9,214.9,148.3z"
        />
      </g>
    </g>
    <g
      id="Color_2"
      className={`${isolatedLayer === 3 ? "fill-group focus" : "fill-group"} `}
    >
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M137.6,177.4c-6.7-2.5-16.6-2.3-22.3,3.7c0.2-1.6-1-3.1-1.8-3.1c-35.1-1.8-69.9-1-104.9-1.5
		c-7-0.1-6.4,9-4.8,11.4c4.3,6.8,14.4,1.2,22.6,2.4c2,0.3-0.6-2.5,0.1-3.6c0.4-0.6,1.6,0.2,2.4,0.7c-0.6,0.3-1.2,0.6-1.7,0.9
		c4.6,6.2,14,0.3,21,1.2c2.4,0.3,0.4-4.6,3.4-3.9c1.7,0.4-1.2,4,1.9,4c6.5-0.1,12.7,2,19.2,0.5c2.1-0.5,1.9-3,1.8-5
		c4.3,0-1.7,5.7,2.7,5c6.3-1,16.3,3.4,19.4-3.5c0.1-0.2,1-0.1,1.6-0.1c-0.2,1.6,1.1,3.1,1.8,3.1c4.5-0.2,9.9,3.7,14.3-1.3
		c1.1-1.3,2.5,1.6,3.3,1.7c7.2,1,16,3.2,21-1.4C140.3,186.7,142.1,179.1,137.6,177.4z M60.2,183.4c-0.7-0.1-1.3-0.8-0.8-1.6
		c1.5-2.4,1.6,0.9,2.6,0.8C61.4,182.9,60.8,183.4,60.2,183.4z M87.3,182.2c-0.8,0.4-1.3-0.2-0.8-0.7c0.3-0.3,1.1-0.1,1.6-0.1
		C87.9,181.7,87.7,182.1,87.3,182.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M286.6,176.2c-12.2,0.2-22.3,1.2-35.1-0.4c-10.2-1.3-20.8,1.7-31.4,1.1c-19.1-1.1-41.1-1.5-56.9,0.5
		c-1.3,0.2-1.9,2.2-1.7,4c-0.6,0-1.2,0-1.7,0c0.2-1.8-0.4-3.8-1.9-4c-3.1-0.5-7.5-2-9,1.8c-1.8,4.6-0.9,10.2-0.4,15.5
		c0.2,1.9-1.2,4-2.5,4C100,198,54,197.3,8,197.9c-1.3,0-4.7-0.6-5,2.1c-0.5,5.3-0.3,10.5,0.1,15.7c0.2,1.8,1.2,3,3.4,2.6
		c3.2-0.5,0.1-3.4,1.7-4.3c0.5-0.2,1.1-0.1,1.7-0.1c-0.4,1.6-1.8,3.9,0.9,4.1c25.7,1.5,51.3,0,76.9,0c2.4,0,0.5-4.2,3.4-4.3
		c-0.4,1.6-1.8,4,0.9,4.1c30.3,0.3,60.6,1.3,90.9,0.9c13.6-0.2,27.3-1,41.1-0.1c17.5,1.1,34.9,0.8,52.4-0.8c3.4-0.3,9.2,1.4,9.7-2.3
		C288,202.4,288.7,189.3,286.6,176.2z M36.8,201.4c0.3,0.1,0.3,1.2,0,1.5c-0.3,0.3-1.4,0.3-1.5,0C34.7,201.9,35.7,200.8,36.8,201.4z
		 M19.4,204.8c-0.5,0.1-1.2-0.8-0.8-1.5c0.4-0.7,1.1-1.2,1.7-1.8C20.1,202.7,21,204.5,19.4,204.8z M36.9,212.6
		c-0.3,0.3-1.1,0.1-1.6,0.1c-0.3,0-0.6,0-0.9,0c0.9-0.5,1.2-2.4,2.5-1.6C37.2,211.2,37.2,212.3,36.9,212.6z M54.3,203.6
		c-0.3,0.3-1.1,0.1-1.6,0.1c-0.3,0-0.6,0-0.9,0c0.6-0.6,1.1-1.5,1.7-1.6C54.1,202,54.8,203,54.3,203.6z M70.1,206.8
		c-0.6,0-1.3-0.9-0.8-1.5c0.3-0.3,1.3-0.3,1.5,0C71.5,205.9,70.8,206.8,70.1,206.8z M87.6,206.7c-0.8,0.4-1.2,0-0.8-0.8
		c0.3-0.7,1-1.4,1.6-0.8C88.9,205.7,88.3,206.4,87.6,206.7z M136.7,206.8c-0.5-0.2,0.1-1.2,0.8-1.5c0.5-0.2,1.4-0.3,1.6,0
		C139.6,206.1,139.1,207.7,136.7,206.8z M156.6,195.4c0.9-0.5,1.1-2.1,2.6-1.8c-0.3,0.9,1.2,1.9-1.7,2.5
		C157.2,196.2,156.9,195.7,156.6,195.4z M161,206.5c-0.6,0.4-1.6,0.2-2.5,0.2c0.3-0.8,0.3-2.2,1.7-1.7
		C160.8,205.2,161.5,206.1,161,206.5z M180.4,213.3c-0.6,0-1.4-1-0.8-1.5c0.6-0.4,2-0.5,2.3,0C182.8,212.9,181.2,213.3,180.4,213.3z
		 M182.8,182.9c0.2-0.3,1.3-0.3,1.5,0c0.4,0.6,0.4,1.8,0,2.4c-0.2,0.3-1.3,0.3-1.5,0C182.4,184.7,182.4,183.5,182.8,182.9z
		 M185.4,200.1c-0.6,0.4-1.8,0.5-2.4,0c-0.6-0.4,0.1-1.3,0.8-1.6c0.5-0.2,1.3-0.3,1.6,0C185.7,198.9,185.7,199.9,185.4,200.1z
		 M205.5,202.6c-0.7,1.6-1.7,0.7-2.6,0.1c0.9-0.5,1.3-2.4,2.5-1.6C205.8,201.2,205.8,202.1,205.5,202.6z M209.8,186.8
		c-0.9,0.3-1.3-0.2-0.8-0.8c0.7-0.8,1-2.2,2.5-1.9C211.2,185.1,212.6,185.9,209.8,186.8z M223.1,212c-0.2,0.7-1,1.5-1.6,1.6
		c-0.6,0.1-1.2-0.8-0.8-1.5c0.4-0.7,1.1-1.2,1.7-1.8C222.6,210.9,223.2,211.5,223.1,212z M230.8,189.1c-1.9,0.5-0.6-1.2-0.7-1.7
		c-0.1-0.6,1-1.3,1.4-0.8C231.9,187.3,232.1,188.8,230.8,189.1z M234.5,202.3c0.3-0.9-1.1-1.7,1.7-2.6
		C235.9,200.5,237.3,201.3,234.5,202.3z M245.1,212.6c-0.5,0.2-1.3,0.3-1.6,0c-0.6-0.6,0.1-1.4,0.8-1.6c0.8-0.2,2.1-0.4,2.4,0
		C247.5,212,245.9,212.3,245.1,212.6z M250.8,182.8c0-0.9-0.3-1.9,0.1-2.5c0.2-0.3,1-0.1,1.6-0.1C252.2,181,253.6,181.9,250.8,182.8
		z M259.8,200.1c-0.3,0-0.6-0.5-0.9-0.8c1-1,2.2-1,3.5-0.9C261.7,199.3,260.8,200,259.8,200.1z M268.4,188.6
		c-0.7-0.1-1.4-1.1-0.8-1.5c0.7-0.4,2.3-0.6,2.3,0.7C269.9,188.1,269,188.6,268.4,188.6z M273.9,208.7c-0.8,0.2-1.7-0.3-1.6-0.8
		c0.1-1,1.6-1.8,2.3-1.6C277.6,207.5,273.4,207.6,273.9,208.7z M281.4,183.3c-0.6-0.3-1.3-0.4-1.7-0.9c-0.3-0.4-0.3-1.2,0-1.6
		c0.5-0.7,1.8-1.5,2.3-0.8C282.8,180.8,281.8,182.1,281.4,183.3z"
      />
    </g>
    <g
      id="Color_1"
      className={`${isolatedLayer === 4 ? "fill-group focus" : "fill-group"} ${
        allLayerFocus && "no-fill"
      }`}
    >
      <g>
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M287.9,4c-10.4-2.6-21-0.3-31.5-0.6c-38.2-1.2-76.3,1.1-114.5,0.2c-10.2-0.2-20.4,0.1-30.6,0.2
			C74.5,4.2,37.8,4.4,1.1,4.1c-0.9,71.7,1,143.4,0.1,215.1c95.9,2.5,191.7-1,287.7,0.7C289.1,147.9,286.2,76,287.9,4z M209.7,44.7
			c5.3,0.7,3.4,7.1,3.6,11c0.9,13.7,1.3,27.3,0.8,41.1c-0.1,1.7,1.7,3.6,1.3,5.1c-1.6,6,2.4,12.6-2.3,17.4c-0.2,0.2-2.1-0.8-2.1-1.5
			c-2-21.6,0.1-43.1-1.6-64.6c-0.1-1.5,0-3.6-1-5.4C207.8,46.8,208.6,44.5,209.7,44.7z M214.4,165.1c-0.9,3.1,1.3,7.6-1.3,10.4
			c-1.3-1.5-2.5-3.2-2.6-5.2c-0.2-16.6-1.1-33.1,0.4-49.8c0-0.1,2-0.2,2.1,0c3,9.2,2.2,18.4,1.9,27.8
			C214.7,153.9,215.9,159.8,214.4,165.1z M195,44.7c0.4-0.5,1.6-0.2,2.5-0.2c3.2,0.1,6.5-0.7,9.6,0.7c-0.6,0.9-1,2.3-1.8,2.4
			c-3.5,0.6-7.2,1.5-10.3-0.7C194.6,46.6,194.6,45.1,195,44.7z M145,44.5c11.9-1,23.9,0.6,35.6-2.4c0.6-0.2-0.2-4,1-6.3
			c4.8,3.1,4,7.1,2.3,9.2c-4.2,5-10.6,2-16.1,2.1c-8.1,0.3-16.4,1.6-24.5-0.3C143.9,46,144.4,44.6,145,44.5z M91.6,44
			c6.6,0.3,13.5-2.2,20.3,1.3c2,1.1,4.2-2.1,5.8-1.2c5.1,2.8,10.3-1.3,15,0.5c0.3,0.1,0.6,0.4,0.9,0.8c0-0.2,0-0.4,0.1-0.7
			c0.9-2.5,6.2-1,9.5-0.2c0.2,0.1,0.4,1.9,0,2.1c-2.4,1.5-6.9,1.4-8.8,0c0.1,0.1,0.1,0.2,0.2,0.3c-11,3.1-23.4,1.6-35,1.5
			c-6.7-0.1-13.4-0.9-20.1-1.1c-0.6,0-1.2-1.4-1.8-2.3C82.1,42.9,87.3,43.8,91.6,44z M73.7,115.1c0.3-9-0.9-18.1-1-27.1
			c0-2.1,0.6-5,0.5-7c-0.4-11.6-1.4-23.4-0.9-34.9c0.1-1.3,5.8-1.5,4.9,1.5c-1,3.2,0.6,6.1,0.4,8.9c-1.2,19.2,0.3,38.5,0.2,57.6
			c-0.1,20.7,2.9,41.6-1.9,62.1c-5.3-10.6-1.2-24-2.4-35.8c-0.1-0.6-1.4-1.2-1.4-1.7c0-0.9,1.4-1.8,1.3-2.6
			C72.9,129.1,73.5,121.7,73.7,115.1z M13,10.3c0.8-2.8,6.8-3,7.9-0.1c1.2,3.1-4.8,1.7-4.8,5.2c0,1.7-0.4,3.6,0.3,5.2
			c0.8,2,3.9,2.7,4.9,0c0.4-1-0.1-2.3,0.2-3.4c0.6-2.1,2.8-4.6,3.9-3.9c3.4,2,0.5,6.7-0.8,9.8c-1.2,2.8-4.3,3.4-7.5,2.8
			c-1.9-0.3-4.6-0.9-4.7-1.7C11.8,19.6,11.8,14.6,13,10.3z M9.2,15.7c0.7-0.2,1.7,0.9,2.6,1.5c-1.2,0.6-2.3,1.2-3.5,1.8
			C8,17.6,8.2,16,9.2,15.7z M8.5,176.5c35,0.5,69.8-0.3,104.9,1.5c0.8,0,2,1.6,1.8,3.1c5.7-6,15.6-6.2,22.3-3.7
			c4.5,1.7,2.7,9.3,0.6,11.3c-5,4.7-13.8,2.5-21,1.4c-0.8-0.1-2.1-3-3.3-1.7c-4.4,5-9.8,1.1-14.3,1.3c-0.7,0-2-1.5-1.8-3.1
			c-0.6,0-1.5-0.1-1.6,0.1c-3.1,6.8-13.1,2.5-19.4,3.5c-4.4,0.7,1.6-5-2.7-5c0.1,2,0.3,4.5-1.8,5c-6.5,1.5-12.7-0.6-19.2-0.5
			c-3.1,0.1-0.1-3.6-1.9-4c-2.9-0.7-1,4.2-3.4,3.9c-7-0.9-16.5,5-21-1.2c0.6-0.3,1.2-0.6,1.7-0.9c-0.8-0.5-2-1.3-2.4-0.7
			c-0.7,1.1,2,3.9-0.1,3.6c-8.1-1.2-18.2,4.4-22.6-2.4C2.2,185.4,1.5,176.4,8.5,176.5z M286.3,215.5c-0.5,3.7-6.3,2-9.7,2.3
			c-17.4,1.6-34.9,1.9-52.4,0.8c-13.8-0.9-27.5-0.1-41.1,0.1c-30.3,0.4-60.6-0.5-90.9-0.9c-2.7,0-1.3-2.5-0.9-4.1
			c-3,0-1,4.3-3.4,4.3c-25.7,0-51.2,1.5-76.9,0c-2.8-0.2-1.3-2.5-0.9-4.1c-0.6,0-1.2-0.1-1.7,0.1c-1.6,0.9,1.4,3.8-1.7,4.3
			c-2.2,0.4-3.2-0.8-3.4-2.6c-0.5-5.2-0.7-10.4-0.1-15.7c0.3-2.7,3.7-2.1,5-2.1c46.1-0.6,92.1,0.1,138.2,0.7c1.3,0,2.7-2,2.5-4
			c-0.5-5.3-1.4-10.9,0.4-15.5c1.5-3.8,5.8-2.2,9-1.8c1.5,0.2,2.1,2.2,1.9,4c0.6,0,1.2,0,1.7,0c-0.3-1.8,0.4-3.8,1.7-4
			c15.7-1.9,37.8-1.5,56.9-0.5c10.6,0.6,21.1-2.4,31.4-1.1c12.8,1.6,22.8,0.6,35.1,0.4C288.7,189.3,288,202.4,286.3,215.5z"
        />
      </g>
    </g>
    <g id="Outline_-_match_color_and_line_weight_to_cell_1">
      <rect
        x="2"
        y="2.7"
        width="285.8"
        height="217.2"
        className="cell-nav-outline"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);

export default React.forwardRef(cell3Nav);
